import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-72">
      <div className="max-w-3xl mx-auto text-center" data-id="element-73">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-74">🧘‍♀️</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-75">
          A propósito de Yoga Lista
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-76">
          Nacimos con una misión clara: devolverle el tiempo y la paz mental a
          las profesoras de yoga en Latinoamérica. Sabemos lo que es correr de
          estudio en estudio, planificar clases a las 11 de la noche y sentir
          que el esfuerzo no rinde. Yoga Lista es el sistema que nos hubiera
          gustado tener cuando empezamos.
        </p>
      </div>
    </section>;
}